import Proxy from './Proxy';

class DelegateProxy extends Proxy {
  /**
   * The constructor for the DelegateProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Delegates', parameters);
  }

  /**
   * Method used to fetch Delegates list.
   *
   * @param {Object} data data to fetch Delegates list
   *
   * @returns {Promise} The result in a promise.
   */
  fetchDelegates(data) {
    return this.submit('post', `${this.endpoint}/list`, data);
  }

  /**
   * Method used to update Delegate.
   *
   * @param {Object} data data to update Delegates
   *
   * @returns {Promise} The result in a promise.
   */
  updateDelegate(data) {
    return this.submit('post', `${this.endpoint}/update`, data);
  }
}

export default DelegateProxy;
